<div class="carrier_depot_details_page">
  <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>
  <div>
    <fieldset class="carrier_details">
      <legend class="header">Carrier Details</legend>
      <div class="detail_row">
        <div class="column">Company registered name:</div>
        <div class="column">{{ carrierDetails.registered_name }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Company registered number:</div>
        <div class="column">{{ carrierDetails.registration_number }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Trading name:</div>
        <div class="column">{{ carrierDetails.trading_name }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Type of carrier:</div>
        <div class="column">{{ carrierDetails.freight_passenger_ind }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Email Address:</div>
        <div class="column">{{ carrierDetails.email }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Telephone:</div>
        <div class="column">
          {{ carrierDetails.dial_code_tele }} {{ carrierDetails.telephone }}
        </div>
      </div>
    </fieldset>
    <fieldset class="carrier_details">
      <legend class="header">Carrier Details</legend>
      <div class="detail_row">
        <div class="column">Company registered name:</div>
        <div class="column">{{ carrierDetails.registered_name }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Company registered number:</div>
        <div class="column">{{ carrierDetails.registration_number }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Trading name:</div>
        <div class="column">{{ carrierDetails.trading_name }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Type of carrier:</div>
        <div class="column">
          {{ carrierDetails.freight_passenger_ind | carrierType }}
        </div>
      </div>
      <div class="detail_row">
        <div class="column">Email Address:</div>
        <div class="column">{{ carrierDetails.email }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Telephone:</div>
        <div class="column">
          {{ carrierDetails.dial_code_tele }} {{ carrierDetails.telephone }}
        </div>
      </div>
      <div class="detail_row">
        <div class="column">Cellphone:</div>
        <div class="column">
          {{ carrierDetails.dial_code_cell }} {{ carrierDetails.cellphone }}
        </div>
      </div>
    </fieldset>
    <fieldset class="carrier_details">
      <legend class="header">
        <span>Depot Info</span>
        <!-- <div class="button_icons">
          <button type="button" class="icon_button">
            <img src="assets/delete.png" alt="" /> Delete
          </button>
        </div> -->
      </legend>
      <div class="detail_row" *ngIf="branches.length > 0">
        <div class="column">Carrier ID:</div>
        <div class="column">{{ depotDetails.carrier_id }}</div>
      </div>
      <div class="detail_row" *ngIf="branches.length > 0">
        <div class="column">Branch:</div>
        <div class="column">{{ depotDetails.branch_carrier_id }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Depot Type:</div>
        <div class="column">{{ depotDetails.depot_type }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Name:</div>
        <div class="column">{{ depotDetails.name }}</div>
      </div>
      <div class="detail_row">
        <div class="column">No of vehicles:</div>
        <div class="column">{{ depotDetails.number_of_vehicles }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Telephone:</div>
        <div class="column">{{ depotDetails.telephone }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Address:</div>
        <div class="column">{{ depotDetails.physical_address_1 }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Town:</div>
        <div class="column">{{ depotDetails.physical_address_town }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Post Code:</div>
        <div class="column">{{ depotDetails.physical_post_code }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Country:</div>
        <div class="column">South Africa</div>
      </div>
      <div class="detail_row">
        <div class="column">Notes:</div>
        <div class="column">{{ depotDetails.notes }}</div>
      </div>
    </fieldset>
    <fieldset class="carrier_details">
      <legend class="header">
        <span>RCP Info</span>
        <!-- <div class="button_icons">
          <button type="button" class="icon_button">
            <img src="assets/delete.png" alt="" /> Delete
          </button>
        </div> -->
      </legend>
      <div class="detail_row">
        <div class="column">ID type:</div>
        <div class="column">{{ depotDetails.id_type_ind }}</div>
      </div>
      <div class="detail_row">
        <div class="column">ID Number:</div>
        <div class="column">{{ depotDetails.id_number }}</div>
      </div>
      <div class="detail_row">
        <div class="column">First Name:</div>
        <div class="column">{{ depotDetails.first_name }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Last Name:</div>
        <div class="column">{{ depotDetails.last_name }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Date of Birth:</div>
        <div class="column">{{ depotDetails.date_of_birth | date }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Gender:</div>
        <div class="column">{{ depotDetails.gender }}</div>
      </div>
      <div class="detail_row">
        <div class="column">Cellphone:</div>
        <div class="column">
          {{ depotDetails.dial_code_cell }} {{ depotDetails.cellphone }}
        </div>
      </div>
      <div class="detail_row">
        <div class="column">Email Address:</div>
        <div class="column">{{ depotDetails.email }}</div>
      </div>
      <table style="width: 100%">
        <tr *ngFor="let Document of viewDocuments">
          <td>
            <div class="card">
              <h5 class="card-title">Files Uploaded</h5>

              <div class="card-body">
                <!-- <h2>Files Uploaded(0)</h2> -->

                <div class="row">
                  <div class="col-sm bg-light">
                    {{ Document.file_name }}
                  </div>
                  <div class="col-sm bg-light">PDF</div>
                  <div class="col-sm bg-light">
                    <span style="float: right !important">
                      <div class="file-upload-icons-group">
                        <a><img title="View Document" class="file-upload-icon" src="/assets/visibility.png"
                            alt="visibility" data-toggle="modal" data-target="#depotViewDoc2" (click)="
                            viewDoc(
                              Document.document_type_id,
                              Document.document_link
                                        )
                                      " /></a>
                        
                      </div>
                      <!-- <span title="Upload another of the same type" *ngIf="UserDocument.multiple_allowed == true" class="btn btn-primary btn-sm"><i
                          class="fa fa-plus" aria-hidden="true" (click)="extraDoc(UserDocument)"></i></span> -->
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </td>

          <td></td>
        </tr>
      
      </table>

      <!-- <div class="detail_row">
            <div class="column">Notes:</div>
            <div class="column">leave package at door step</div>
        </div> -->
    </fieldset>
    <div class="action_btns">
      <div class="btn_wrap">
        <button type="submit" (click)="back()" class="btn btn_primary">
          Done
        </button>
      </div>
    </div>
  </div>
</div>


<div
  class="modal fade"
  id="depotViewDoc2"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLongTitle"
  aria-hidden="true"
>
<div class="modal-dialog modal-lg" tabindex="-1" aria-hidden="true" role="document">
  <div class="modal-content">
      <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Depot Document View</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
      </div>
      <div class="modal-body modal-lg">
        <div style="width: 99%; min-height: 470px">
          <pdf-viewer
            *ngIf="pdfSrc"
            [src]="pdfSrc"
            [render-text]="true"
            style="display: block"
            [original-size]="false"
            [autoresize]="true"
          ></pdf-viewer>
          <ngx-loading [show]="isLoading"></ngx-loading>
        </div>
      </div>
      <div class="modal-footer">
          <button type="button" class="btn pull-right btn_secondary" data-dismiss="modal">Close</button>
           <!-- <button type="button" class="btn btn-primary">Save changes</button>  -->
</div>
</div>
</div>
</div>